import {Injectable} from "@angular/core";
import {Adapter} from "./adapter";

export class uom {

    public UOM_ID = null;
    public UOM = null;
    public UOM_Desc = null;
    public UseForStrength = null;
    public Active = null;
    public CreatedBy = null;
    public CreatedOn = null;
    public ModifiedBy = null;
    public ModifiedOn = null;

    constructor(public initVal: Partial<uom>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class uomAdapter implements Adapter<uom> {
    adapt(item: any): uom {
        return new uom(item);
    }
}